import { Box } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Toolbar from "@mui/material/Toolbar";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import React, { useContext } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import EmbedContext from "../../../context/Embed";
import UserContext from "../../../context/User";
import useStyle from "./styles";
import Logo from "../../../assets/images/logo.png";
import { useTranslation } from "react-i18next";
import BecomePartnerLink from "../BecomePartnerLink";
import TopBar from "../TopBar";
import { C, FONT_BODY, FOCUS_RING, RADIUS } from "../../../utils/designTokens";

function LoginDesktopHeader({ showIcon, showCart = false, showFullHeader = false }) {
  const { t } = useTranslation();
  const classes = useStyle();
  const location = useLocation();
  // Embed mode (partner iframe pinned to one restaurant): logo must not
  // navigate away from the pinned restaurant's order flow.
  const { isEmbed } = useContext(EmbedContext);
  // A signed-out visitor can still fill a bag; the top bar shows its count.
  const { cartCount = 0, otherCartsCount = 0 } = useContext(UserContext) || {};

  // Simple header for home page and auth pages
  if (!showFullHeader) {
    return (
      <AppBar elevation={0} position="fixed" className={classes.root}>
        <Toolbar className={classes.toolbar}>
          {/* Logo */}
          {isEmbed ? (
            <img src={Logo} alt="RushmyFood" style={{ height: 40, objectFit: "contain" }} />
          ) : (
          <RouterLink
            to={location.pathname === "/checkout" ? "/restaurant-list" : "/"}
            className={classes.linkDecoration}
          >
            <img src={Logo} alt="RushmyFood" style={{ height: 40, objectFit: "contain" }} />
          </RouterLink>
          )}

          {/* Right Section */}
          <Box className={classes.rightSection}>
            <BecomePartnerLink />
            {showIcon && (
              <RouterLink to={"/login"} className={classes.linkDecoration}>
                <Button
                  sx={{
                    borderRadius: "24px",
                    backgroundColor: "transparent",
                    padding: "8px 20px",
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "0.875rem",
                    color: "#191919",
                    border: "1px solid #191919",
                    "&:hover": {
                      backgroundColor: "rgba(0,0,0,0.04)",
                    },
                  }}
                >
                  {t("loginBtn")}
                </Button>
              </RouterLink>
            )}
            {showCart && (
              <RouterLink to="/checkout" className={classes.linkDecoration}>
                <Box className={classes.iconButton}>
                  <ShoppingBagOutlinedIcon sx={{ color: "#191919", fontSize: 22 }} />
                </Box>
              </RouterLink>
            )}
          </Box>
        </Toolbar>
      </AppBar>
    );
  }

  // Full header: the shared top bar, with Sign in on the right. Its phone
  // second row (search on the Restaurants screen) lives in TopBar too.
  return (
    <TopBar
      account={showIcon ? (
        <Box
          component={RouterLink}
          to="/login"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            height: 44,
            px: 2,
            flexShrink: 0,
            borderRadius: RADIUS.pill,
            border: `1px solid ${C.ink}`,
            color: C.ink,
            textDecoration: "none",
            fontFamily: FONT_BODY,
            fontWeight: 600,
            fontSize: 14,
            whiteSpace: "nowrap",
            "&:hover": { bgcolor: C.surface2 },
            ...FOCUS_RING,
          }}
        >
          {t("loginBtn")}
        </Box>
      ) : null}
      showCart={showCart}
      cartCount={cartCount + (otherCartsCount || 0)}
      cartHref={otherCartsCount > 0 ? "/carts" : "/checkout"}
      logoTo={location.pathname === "/checkout" ? "/restaurant-list" : "/"}
    />
  );
}

export default React.memo(LoginDesktopHeader);
